interface SelectItemIconProps {
  children: React.ReactNode;
  variant?: "primary" | "secondary";
}

const SelectItemIcon = ({
  children,
  variant = "primary",
}: SelectItemIconProps) => {
  const variantClasses = {
    primary: "bg-gradient-to-br from-blue-500 to-blue-600 text-white",
    secondary: "bg-gradient-to-br from-gray-400 to-gray-500 text-white",
  };

  return (
    <div
      className={`flex h-5 w-5 items-center justify-center rounded-md ${variantClasses[variant]} text-xs font-semibold shadow-sm`}
    >
      {children}
    </div>
  );
};

export default SelectItemIcon;
